// extracted by mini-css-extract-plugin
module.exports = {"form":"ForgotPasswordPage_form__1FVYu","label":"ForgotPasswordPage_label__wrX1Q","button-wrapper":"ForgotPasswordPage_button-wrapper__3ZoxF"};